export const translations = {
    "ar": () => import(/*webpackChunkName: 'calendar-t-ar'*/"../translations/ar"),
    "de": () => import(/*webpackChunkName: 'calendar-t-de'*/"../translations/de"),
    "en": () => import(/*webpackChunkName: 'calendar-t-en'*/"../translations/en"),
    "es": () => import(/*webpackChunkName: 'calendar-t-es'*/"../translations/es"),
    "fr": () => import(/*webpackChunkName: 'calendar-t-fr'*/"../translations/fr"),
    "id": () => import(/*webpackChunkName: 'calendar-t-id'*/"../translations/id"),
    "ru": () => import(/*webpackChunkName: 'calendar-t-ru'*/"../translations/ru"),
    "tr": () => import(/*webpackChunkName: 'calendar-t-tr'*/"../translations/tr"),
    "zh-cht": () => import(/*webpackChunkName: 'calendar-t-zh-cht'*/"../translations/zh-cht"),
    "zh-cn": () => import(/*webpackChunkName: 'calendar-t-zh-cn'*/"../translations/zh-cn"),
    "vi": () => import(/*webpackChunkName: 'calendar-t-vi'*/"../translations/vi"),
    "fa": () => import(/*webpackChunkName: 'calendar-t-fa'*/"../translations/fa"),
    "pt": () => import(/*webpackChunkName: 'calendar-t-pt'*/"../translations/pt"),
    "cs": () => import(/*webpackChunkName: 'calendar-t-cs'*/"../translations/cs"),
}

export const fetchLocalizations = async (store) => {
    const storeCulture = store.getState().config.culture
    const culture = storeCulture ? storeCulture.toLowerCase() : 'en'

    const currentCulture = translations.hasOwnProperty(culture) ? culture : 'en'

    const fetchedTranslations = await translations[currentCulture]()

    return {
        translations: fetchedTranslations.default
    }
}
